import embed from "./site/embed.ts";
import gallery from "./site/gallery.ts";
import masonry from "./site/masonry.ts";
import nav from "./site/nav.ts";
// import observe from "./site/observer.ts";
import render from "./site/router.ts";

render(($container) => {
    embed($container);
    gallery($container);
    masonry($container);
    nav($container);
});